import {
  ListScheduledDowntimeResponse,
  ScheduledDowntime,
  ScheduledDowntimeUpsertRequest,
  TicketScannerScheduledDowntimeApi,
} from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const list = async (includePast?: boolean): Promise<ListScheduledDowntimeResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(TicketScannerScheduledDowntimeApi)
  return await api.listScannerScheduledDowntime({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    includePast,
  })
}

const create = async (body: ScheduledDowntimeUpsertRequest): Promise<ScheduledDowntime> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(TicketScannerScheduledDowntimeApi)
  return await api.createScannerScheduledDowntime({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    scheduledDowntimeUpsertRequest: body,
  })
}

const update = async (
  id: string,
  body: ScheduledDowntimeUpsertRequest,
): Promise<ScheduledDowntime> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(TicketScannerScheduledDowntimeApi)
  return await api.updateScannerScheduledDowntime({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    id,
    scheduledDowntimeUpsertRequest: body,
  })
}

const remove = async (id: string): Promise<void> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(TicketScannerScheduledDowntimeApi)
  await api.deleteScannerScheduledDowntime({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    id,
  })
}

export const ScannerScheduledDowntimeAPI = {
  list,
  create,
  update,
  delete: remove,
}
